import React, { useRef, useState, useEffect, createRef, useMemo } from 'react'
import {
    Box, Button, ButtonGroup,
    Flex, IconButton, Input, Text,
    HStack, VStack, Stack, Avatar, Divider,
    Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton,
    useDisclosure, WrapItem,
    Select,
} from '@chakra-ui/react'
import { FaLocationArrow, FaTimes, FaRocketchat, FaSearch, FaCar, FaPlus, FaGripVertical } from 'react-icons/fa'

import {
    useJsApiLoader,
    GoogleMap,
    Marker,
    InfoWindow,
    Autocomplete,
    DirectionsRenderer,
    Polyline,
    MarkerClusterer
} from '@react-google-maps/api'

import {
    DragDropContext,
    Droppable,
    Draggable
} from '@hello-pangea/dnd';

import UserService from '../../services/UserService';
import DriverService from '../../services/DriverService';
import CommonService from '../../services/CommonService';
import { io } from "socket.io-client";
import config from '../../constants/config';
import Footer from '../../components/user/Footer';
import { calculateAge, getGender, getMusic } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { clearPassengerRideData, getPassengerRideDataFromStorage, setPassengerRideDataInStorage } from '../../utils/localStorage';
import { useDispatch, useSelector } from 'react-redux';
import { selectCandelRideData, setCancelRideData } from '../../store/features/cancelRideSlice';
import PassengerRatingModal from './PassengerRatingModal';
import DriverRatingModal from '../driver/DriverRatingModal';
import RouteMarkers from '../../components/RouteMarkers';
import { parseLocation, sameDrive, updateDriverPosition } from '../../utils/liveLocation';

const libraries = ['places', 'geometry'];

function UserMapWithDirection() {

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
    })

    const backendUrl = config.apiBaseUrl;
    // const socket = io(`${config.apiBaseUrl}`); // Backend server URL
    const user = JSON.parse(localStorage.getItem("user"));
    const rideSession = getPassengerRideDataFromStorage();
    const dispatch = useDispatch();
    const candelRideState = useSelector(selectCandelRideData)

    const navigate = useNavigate();
    const socketRef = useRef(null);
    const passengerIntervalRef = useRef(null);
    const driverInfoRef = useRef(null);
    const activeDriverRef = useRef(null);
    const latestDriverLocationRef = useRef(null);
    const rideStatusRequestRef = useRef(0);
    const [activeDriver, setActiveDriver] = useState(null);

    const [map, setMap] = useState((null))
    const [center, setCenter] = useState({ lat: 19.0760, lng: 72.8777 });
    const [directionsResponse, setDirectionsResponse] = useState(null)
    const [distance, setDistance] = useState('')
    const [duration, setDuration] = useState('')
    const [selectedRouteIndex, setSelectedRouteIndex] = useState(0)
    const [Drivers, setDrivers] = useState([]);
    const [bookedPassenger, setBookedPassenger] = useState([]);
    const [paymentMode, setPaymentMode] = useState("");
    const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);

    const [location, setLocation] = useState({
        lat: parseFloat(0),
        lng: parseFloat(0),
        name: null,
    });

    const [driverRoute, setDriverRoute] = useState('')
    const [passenger, setPassenger] = useState('')

    const [passengerMarker, setPassengerMarker] = useState('')
    const [driverMarker, setDriverMarker] = useState('')
    const [DriverInfo, setDriverInfo] = useState({
        DriveNo: null,
        DriverId: null,
        Name: null,
    });

    const [routePolylines, setRoutePolylines] = useState([]);
    const [colorPolylines, setColorPolylines] = useState([]);

    const [messages, setMessages] = useState([])
    const [reply, setReply] = useState([])
    const [amount, setAmount] = useState(0);
    const [ReqNo, setReqNo] = useState(0);
    const [ReqStat, setReqStat] = useState(0);
    const [searchSection, setSearchSection] = useState(true)

    const [origin, setOrigin] = useState("");
    const [destination, setDestination] = useState("");
    const [waypoints, setWaypoints] = useState([]);
    const [localWaypointValues, setLocalWaypointValues] = useState(waypoints);

    const originRef = useRef(null)
    const destinationRef = useRef(null)
    const waypointRefs = useRef([]);

    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = useRef()

    const selectedDirections = useMemo(() => {
        const route = directionsResponse?.routes[selectedRouteIndex];
        return route ? { ...directionsResponse, routes: [route] } : null;
    }, [directionsResponse, selectedRouteIndex]);


    const getChats = async (driveNo) => {
        const chats = await CommonService.getChating(driveNo, user.uId);
        setMessages(chats)
    };

    const passengerReply = async (driveNo) => {
        let params = {};
        params.DriveNo = driveNo;
        params.PassengerId = user.uId;
        if (driveNo > 0) {
            const rply = await CommonService.getPassengerReply(params);
            setReply(rply)
        }
    };

    const getCurrentOrigin = async () => {
        let params = { uId: user.uId }
        try {
            const res = await DriverService.getCurrentFullAddress(params)
            if (res.statusCode === 200) {
                if (origin == "") {
                    setOrigin(res.data.location);
                }
                setCenter({ lat: res.data.lat, lng: res.data.lng })
            }
        } catch (error) {
            console.log(`Error setting origin: ${error}`);

        }
    }

    const getCurrentLocation = () => {
        if (!navigator.geolocation) {
            setLocation({ ...location, name: user.FName });
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                // setLocation({ lat: 21.261615992285048, lng: 81.57565935083485, name: user.FName });
                setLocation({ lat: position.coords.latitude, lng: position.coords.longitude, name: user.FName });
                // Update the center state to re-center the map
                // setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                if (rideSession.ReqNo > 0) {
                    currentLatLng(position.coords.latitude, position.coords.longitude, rideSession.ReqNo)
                }
            },
            (err) => {
                setLocation({ ...location, name: user.FName });
                console.log(err.message)
            }
        );
    };

    const currentLatLng = async (lat, lng, reqNo = null) => {
        let params = {
            ReqNo: reqNo || rideSession.ReqNo || getPassengerRideDataFromStorage().ReqNo,
            PassengerId: user.uId,
            lat: lat,
            lng: lng
        }
        try {
            await UserService.saveCurrentLatLng(params);
        } catch (error) {
            if (error.response?.status === 401) {
                alert(error.response.data.message);
            } else {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        }
    }

    const checkBookedRide = async () => {
        const requestId = ++rideStatusRequestRef.current;
        const latestSession = getPassengerRideDataFromStorage()
        let params = {
            ReqNo: latestSession.ReqNo,
            DriveNo: latestSession.DriveNo
        }

        if (latestSession.DriveNo > 0 && latestSession.ReqNo > 0) {
            try {
                const res = await UserService.checkBookedRide(params);
                if (requestId !== rideStatusRequestRef.current) return;
                const currentSession = getPassengerRideDataFromStorage();
                if (!sameDrive(currentSession.DriveNo, latestSession.DriveNo) ||
                    String(currentSession.ReqNo) !== String(latestSession.ReqNo)) return;
                if (res.statusCode === 200) {
                    if (Number(res?.data?.Stat) === 1) {
                        setSearchSection(false)
                        activeDriverRef.current = latestSession.DriveNo;
                        // Restore A even if the moving car no longer matches the
                        // original pickup search radius after a page refresh.
                        const drivers = await DriverService.getBookedDriver({
                            uId: user.uId,
                            ReqNo: latestSession.ReqNo,
                            authToken: user.authToken,
                        });
                        if (requestId !== rideStatusRequestRef.current ||
                            !sameDrive(activeDriverRef.current, latestSession.DriveNo)) return;
                        const booked = drivers?.find(driver => sameDrive(driver.DriveNo, latestSession.DriveNo));
                        const latest = latestDriverLocationRef.current;
                        const position = sameDrive(latest?.DriveNo, latestSession.DriveNo)
                            ? latest : parseLocation(booked?.drivecurrlatlng?.[0]) || parseLocation(booked);
                        setActiveDriver({ DriveNo: latestSession.DriveNo, ...position });
                    } else {
                        activeDriverRef.current = null;
                        setActiveDriver(null);
                    }
                }
            } catch (error) {
                if (error.response?.status === 401) {
                    alert(error.response.data.message);
                } else {
                    alert("Something went wrong. Please try again.");
                    console.error(error);
                }
            }
        }
    };

    const routeCreate = async () => {
        try {
            const res = await UserService.getCurrentRouteDetail(rideSession.ReqNo);
            if (res.statusCode === 200) {
                if (res.data.length > 0) {
                    console.log(res.data)
                    setOrigin(res.data[0].Frmloc)
                    setDestination(res.data[0].Toloc)

                    // setReqNo(rideSession.ReqNo)

                    setLocation({ lat: res.data[0].lat, lng: res.data[0].lng, name: user.FName })

                    calculateRouteWithParam(res.data[0].Frmloc, res.data[0].Toloc);
                }
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert(error.response.data.message);
            } else {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        }
    }

    const drivingDrivers = async (lat, lng, endLat, endLng) => {
        let passenger = { lat: lat, lng: lng, endLat: endLat, endLng: endLng };
        setDrivers([]);
        let params = {
            uId: user.uId,
            authToken: user.authToken,
            CompCd: user.CompCd,
            role: user.role
        };

        try {
            const driverList = await DriverService.getDrivingDrivers(params);

            // setDrivers(driverList);
            const activeDriveNo = activeDriverRef.current;
            const matchedDrivers = activeDriveNo
                ? driverList.filter(driver => sameDrive(driver.DriveNo, activeDriveNo))
                : await findMatchingDrivers(passenger, driverList, map);

            setDrivers(matchedDrivers);

            // if (driverRoute.length > 0) {

            //     const matchedDrivers = await findMatchingDrivers(passenger, driverList);
            //     setDrivers(matchedDrivers);
            // } else {
            //     setDrivers(driverList);
            // }

        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const findMatchingDrivers = async (passenger, drivers, map) => {

        const passengerRoute = await getPassengerRoute(passenger);
        const matchedDrivers = [];

        for (const driver of drivers) {
            const driverRoute = await getDriverRoute(driver);

            if (driverRoute.length === 0) continue;

            const overlapPercentage = calculateRouteOverlap(driverRoute, passengerRoute); // 500 meter
            const canReach = await canDriverReachPassenger(driver, passenger); // 10 minuts

            const driverLatLng = new window.google.maps.LatLng(driver.lat, driver.lng);
            const passengerLatLng = new window.google.maps.LatLng(passenger.lat, passenger.lng);
            const destinationLatLng = new window.google.maps.LatLng(passenger.endLat, passenger.endLng);

            const passed = hasDriverPassedPassenger(driverLatLng, passengerLatLng, destinationLatLng); // New logic over cross 15 meter

            console.log(`o ${overlapPercentage}, c ${canReach} , p ${passed}`)
            // overlapPercentage > 50 && canReach && !passed)
            const overoverlapperc = user.config.overlapPercentage || 50;
            if (overlapPercentage > overoverlapperc && canReach && !passed) {

                matchedDrivers.push({
                    ...driver,
                    overlapPercentage,
                    canReachIn10Min: canReach,
                });

            }
        }

        return matchedDrivers;
    };

    const kycTest = async () => {
        const params = {
            uId: user.uId,
            authToken: user.authToken
        };
        try {
            const res = await CommonService.checkKYC(params);
            if (res.statusCode === 200) {
                if (res.data.kycStat === 5 && res.data.compStat === 5) {
                    return true;
                } else {
                    navigate("/user/kyc");
                    return false;
                }
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return false;
        }
    };

    useEffect(() => {
        let cancelled = false;
        const runKycFlow = async () => {
            const isKycPassed = await kycTest();
            if (isKycPassed && !cancelled) {
                await checkBookedRide();
                if (cancelled) return;

                if (rideSession.ReqNo > 0) {
                    setReqNo(rideSession.ReqNo)
                    routeCreate();
                }

                const saveLatLngSeconds = (user.config.saveLatLngSeconds || 10) * 1000; // 10 seconds
                if (!passengerIntervalRef.current) {
                    passengerIntervalRef.current = setInterval(getCurrentLocation, saveLatLngSeconds);
                }
                setTimeout(getCurrentOrigin, 100); // Delay to ensure DOM is ready

                setLocalWaypointValues(waypoints);

                // if (waypoints.length > 0) {
                //     calculateRoute()
                // }
                if (driverMarker) {
                    setDriverMarker(null);
                }

                routePolylines.forEach(poly => poly.setMap(null));
                setRoutePolylines([]);

                // socket.on("connect", () => {
                //     console.log("Connected to WebSocket");
                // });

                // socket.on("receive_message", (msg) => {
                //     // console.log("Received:", msg);
                //     if (msg.MsgId === 20 || msg.MsgId === 28) {
                //         setReqNo(0)
                //         // session
                //         user.ReqNo = 0;
                //         localStorage.setItem("user", JSON.stringify(user));
                //     }

                //     if (DriverInfo?.DriveNo) {
                //         getChats(DriverInfo.DriveNo);
                //         passengerReply(DriverInfo.DriveNo);
                //     }
                // });

                // socket.on('updateDriverLocation', ({ DriveNo, location }) => {
                //     setDrivers(prevDrivers =>
                //         prevDrivers.map(driver =>
                //             driver.DriveNo === DriveNo
                //                 ? { ...driver, lat: parseFloat(location.lat), lng: parseFloat(location.lng) }
                //                 : driver
                //         )
                //     );

                // });

                return () => {
                    // socket.off('updateDriverLocation');
                    // socket.disconnect();
                };

            }
        }
        runKycFlow();
        return () => { cancelled = true; };

    }, [isLoaded]);

    useEffect(() => {
        if (waypoints.length > 0) {
            calculateRoute();
        }
    }, [waypoints]);

    useEffect(() => {
        initializeSocket();
        return () => {
            stopTrackingAndSocket();
        };
    }, []);

    useEffect(() => {
        driverInfoRef.current = DriverInfo;
    }, [DriverInfo]);

    const handleCancelRideByPassenger = async () => {
        try {
            let params = {};
            params.DriverId = DriverInfo.DriverId;
            params.DriveNo = DriverInfo.DriveNo;
            params.uId = user.uId;
            params.MsgId = 29;
            params.Rate = 0;
            params.msg = 'Passenger Cancels Ride';
            params.PStat = 0;
            params.DStat = 0;
            params.SendBy = user.uId;
            params.MobileNo = user.MobileNo;
            params.ReqNo = rideSession.ReqNo;
            // for passenger picked dropped
            params.RegNo = user.RegNo;
            params.RLat = 0;
            params.RLng = 0;
            params.authToken = user.authToken
            // Save passenger reply
            const res = await UserService.savePassengerReply(params);
            // Send socket message
            socketRef.current.emit("send_message", {
                senderId: user.uId,
                receiverId: DriverInfo.DriverId,
                messageData: {
                    MsgId: 12,
                    msg: "Passenger Cancels Ride",
                    ReqNo: ReqNo,
                },
            })
            dispatch(setCancelRideData(""))
            clearIntervalOnly()
            clearRoute()
            navigate(0);
        }
        catch (error) {
            console.error("Error cancelling ride:", error);
        }
    }

    useEffect(() => {
        if (candelRideState == "cancel-by-passenger") {
            handleCancelRideByPassenger()
        }
    }, [candelRideState]);

    const initializeSocket = () => {

        if (socketRef.current) return;

        socketRef.current = io(config.socketUrl, {
            path: config.socketPath
        });

        socketRef.current.on("connect", () => {
            console.log("Connected to WebSocket");
            socketRef.current.emit("register", user.uId);
            checkBookedRide();
        });

        socketRef.current.on("receive_message", (msg) => {
            console.log("Passenger Log", "Received:", msg);
            const { senderId, messageData } = msg // here sender is driver
            if ([19, 20, 22, 24, 25, 28, 29].includes(Number(messageData.MsgId)) &&
                String(senderId) === String(getPassengerRideDataFromStorage().DriverId)) {
                rideStatusRequestRef.current++;
                activeDriverRef.current = null;
                latestDriverLocationRef.current = null;
                setActiveDriver(null);
            }
            if (messageData.MsgId === 20 || messageData.MsgId === 28) {
                setReqNo(0)
                // session
                // user.ReqNo = 0;
                // localStorage.setItem("user", JSON.stringify(user));
                setPassengerRideDataInStorage({
                    ReqNo: 0
                });
            }
            if (messageData.MsgId == 12) {
                checkBookedRide()
            }
            const currentDriverInfo = driverInfoRef.current;
            if (currentDriverInfo?.DriveNo) {
                getChats(currentDriverInfo.DriveNo);
                passengerReply(currentDriverInfo.DriveNo);
            }
        });

        socketRef.current.on('updateDriverLocation', ({ DriveNo, location }) => {
            const position = parseLocation(location);
            if (!position) return;
            const session = getPassengerRideDataFromStorage();
            if (session.ReqNo > 0 && sameDrive(session.DriveNo, DriveNo)) {
                latestDriverLocationRef.current = { DriveNo, ...position };
                if (sameDrive(activeDriverRef.current, DriveNo)) {
                    setActiveDriver({ DriveNo, ...position });
                }
            }
            setDrivers(prevDrivers =>
                prevDrivers.map(driver => updateDriverPosition(driver, DriveNo, position))
            );
            setDriverMarker(driver => updateDriverPosition(driver, DriveNo, position));
        });
    };
    // =========================
    // CLEANUP
    // =========================
    const stopTrackingAndSocket = () => {
        rideStatusRequestRef.current++;
        activeDriverRef.current = null;

        if (passengerIntervalRef?.current) {
            clearInterval(passengerIntervalRef.current);
            passengerIntervalRef.current = null;
        }

        // disconnect socket
        if (socketRef?.current) {
            socketRef.current.off("receive_message");
            socketRef.current?.off("updateDriverLocation");

            socketRef.current.disconnect();
            socketRef.current = null;
        }
    };

    // =========================
    // CLEANUP
    // =========================

    const clearIntervalOnly = () => {
        if (passengerIntervalRef?.current) {
            clearInterval(passengerIntervalRef.current);
            passengerIntervalRef.current = null;
        }
    };

    if (!isLoaded) {
        return <div>Loading map...</div>;
    }

    const handleOrigin = () => {
        const place = originRef.current.getPlace();
        if (place && place.formatted_address) {
            setOrigin(place.formatted_address);
        } else {
            setOrigin("");
        }
    };

    const handleDestination = () => {
        const place = destinationRef.current.getPlace();
        if (place && place.formatted_address) {
            setDestination(place.formatted_address);
        } else {
            setDestination("");
        }
    };

    const getBookdedDrivers = async () => {
        setDrivers([]);
        let params = {
            uId: user.uId,
            authToken: user.authToken,
            CompCd: user.CompCd,
            role: user.role,
            ReqNo: getPassengerRideDataFromStorage().ReqNo
        };

        try {
            const driverList = await DriverService.getBookedDriver(params);

            // A booked driver must remain visible after passing the pickup.
            setDrivers(driverList.map(driver => ({
                ...driver,
                ...parseLocation(driver.drivecurrlatlng?.[0]),
                drivervehicle: driver.drivervehicle || driver.users?.drivervehicle?.find(
                    vehicle => String(vehicle.DVNo) === String(driver.DVNo)
                ),
            })));
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const addWaypoint = () => {
        setWaypoints([...waypoints, '']);
        waypointRefs.current.push(createRef());
    };

    const removeWaypoint = (index) => {
        if (waypoints.length === 1) {
            setWaypoints([]); // ✅ Clear the array properly
            waypointRefs.current = [];
            setLocalWaypointValues([]);
            calculateRoute()
        } else {
            const updatedWaypoints = waypoints.filter((_, i) => i !== index);
            setWaypoints(updatedWaypoints);
            waypointRefs.current = waypointRefs.current.filter((_, i) => i !== index);
        }

    };

    const updateWaypoint = (index, value) => {
        const newWaypoints = [...waypoints];
        newWaypoints[index] = value;
        setWaypoints(newWaypoints);
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const reordered = Array.from(waypoints);
        const [movedItem] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, movedItem);
        setWaypoints(reordered); // ✅ This triggers re-render and map update

        // Also reorder refs (optional)
        const refCopy = Array.from(waypointRefs.current);
        const [movedRef] = refCopy.splice(result.source.index, 1);
        refCopy.splice(result.destination.index, 0, movedRef);
        waypointRefs.current = refCopy;

    };

    const handleInputChange = (index, value) => {
        const updated = [...localWaypointValues];
        updated[index] = value;
        setLocalWaypointValues(updated);
    };

    const handlePlaceChanged = (index) => {
        const place = waypointRefs.current[index]?.getPlace();
        if (place?.formatted_address) {
            updateWaypoint(index, place.formatted_address); // update main state
            calculateRoute();
        }
    };

    async function calculateRoute() {

        if (user.subscription < 1) {
            alert(`Your Subscription has been expired. Please recharge`);
            navigate('/user/payment')
        }

        if (origin === '' || destination === '') {
            alert(`Please enter origin & destination`);
            return;
        }

        const directionsService = new window.google.maps.DirectionsService();

        let waypointLocations = waypoints
            .filter(w => w !== '')
            .map(w => ({ location: w, stopover: true }));

        try {
            //Full route with waypoints (for rendering)
            const results = await directionsService.route({
                origin: origin,
                destination: destination,
                waypoints: waypointLocations,
                travelMode: window.google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false,
                provideRouteAlternatives: true,
            });

            setDirectionsResponse(results);
            setDistance(results.routes[0].legs[0].distance.text);
            setDuration(results.routes[0].legs[0].duration.text);
            setSelectedRouteIndex(0);

            const routePath = results.routes[0].overview_path.map(point => ({
                lat: point.lat(),
                lng: point.lng(),
            }));
            setDriverRoute(routePath);

            const originLatLng = await getLatLng(origin);
            const destinationLatLng = await getLatLng(destination);
            const dist = results.routes[0].legs[0].distance.text;

            savePassengerLocation(origin, destination, originLatLng, destinationLatLng, dist);
            setPassenger({
                lat: originLatLng.lat(),
                lng: originLatLng.lng(),
                endLat: destinationLatLng.lat(),
                endLng: destinationLatLng.lng(),
            });

            drivingDrivers(originLatLng.lat(), originLatLng.lng(), destinationLatLng.lat(), destinationLatLng.lng());
            if (waypoints.length > 0) {
                saveWaypoint(waypoints);
            }
        } catch (error) {
            console.error("Error calculating route:", error);
            // console or show error using set state
            // alert("Failed to calculate route. Please try again.");
        }
    }

    async function calculateRouteWithParam(origin, destination) {

        if (origin === '' || destination === '') {
            alert(`Please enter origin & destination`);
            return;
        }

        const waitForGoogleMaps = () =>
            new Promise((resolve) => {
                const check = () => {
                    if (window.google && window.google.maps && window.google.maps.DirectionsService) {
                        resolve();
                    } else {
                        setTimeout(check, 100); // wait and check again
                    }
                };
                check();
            });

        await waitForGoogleMaps();

        const directionsService = new window.google.maps.DirectionsService();

        let waypointLocations = waypoints
            .filter(w => w !== '')
            .map(w => ({ location: w, stopover: true }));

        try {
            //Full route with waypoints (for rendering)
            const results = await directionsService.route({
                origin: origin,
                destination: destination,
                waypoints: waypointLocations,
                travelMode: window.google.maps.TravelMode.DRIVING,
                optimizeWaypoints: false,
                provideRouteAlternatives: true,
            });

            setDirectionsResponse(results);
            setDistance(results.routes[0].legs[0].distance.text);
            setDuration(results.routes[0].legs[0].duration.text);
            setSelectedRouteIndex(0);

            const routePath = results.routes[0].overview_path.map(point => ({
                lat: point.lat(),
                lng: point.lng(),
            }));
            setDriverRoute(routePath);

            const originLatLng = await getLatLng(origin);
            const destinationLatLng = await getLatLng(destination);

            // savePassengerLocation(origin, destination, originLatLng, destinationLatLng)
            setPassenger({
                lat: originLatLng.lat(),
                lng: originLatLng.lng(),
                endLat: destinationLatLng.lat(),
                endLng: destinationLatLng.lng(),
            });

            drivingDrivers(originLatLng.lat(), originLatLng.lng(), destinationLatLng.lat(), destinationLatLng.lng());
            // if (waypoints.length > 0) {
            //     saveWaypoint(waypoints);
            // }
        } catch (error) {
            console.error("Error calculating route:", error);
            // console or show error using set state
            // alert("Failed to calculate route. Please try again.");
        }
    }

    const saveWaypoint = async (waypoints) => {

        let params = {
            drv_req_no: ReqNo,
            rType: 2, // 2 - user
            LoginCd: user.uId,
            waypoints: waypoints,
        };
        try {
            await CommonService.saveWaypoints(params);
        } catch (error) {
            console.log(`waypoint error :  ${error}`)
        }
    }

    // get new driver list
    const getNewDriver = async () => {
        if (origin === '' || destination === '') {
            return
        }
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()
        const results = await directionsService.route({
            origin: origin,
            destination: destination,
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: true, // Enable alternative routes
        })

        setDirectionsResponse(results)
        setDistance(results.routes[0].legs[0].distance.text)
        setDuration(results.routes[0].legs[0].duration.text)
        //setSelectedRouteIndex(0) // default to first route

        const routePath = results.routes[0].overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng()
        }));
        setDriverRoute(routePath); // Store driver route points

        const originLatLng = await getLatLng(origin);
        const destinationLatLng = await getLatLng(destination);

        setPassenger({ lat: originLatLng.lat(), lng: originLatLng.lng(), endLat: destinationLatLng.lat(), endLng: destinationLatLng.lng() });
        // driver list
        drivingDrivers(originLatLng.lat(), originLatLng.lng(), destinationLatLng.lat(), destinationLatLng.lng());
    }

    // get new driver list
    const getOnlyBookedDriver = async () => {
        if (origin === '' || destination === '') {
            return
        }
        // driver list
        getBookdedDrivers();

        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()
        const results = await directionsService.route({
            origin: origin,
            destination: destination,
            // eslint-disable-next-line no-undef
            travelMode: google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: true, // Enable alternative routes
        })

        setDirectionsResponse(results)
        setDistance(results.routes[0].legs[0].distance.text)
        setDuration(results.routes[0].legs[0].duration.text)
        //setSelectedRouteIndex(0) // default to first route

        const routePath = results.routes[0].overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng()
        }));
        setDriverRoute(routePath); // Store driver route points

        const originLatLng = await getLatLng(origin);
        const destinationLatLng = await getLatLng(destination);

        setPassenger({ lat: originLatLng.lat(), lng: originLatLng.lng(), endLat: destinationLatLng.lat(), endLng: destinationLatLng.lng() });
    }

    const savePassengerLocation = async (Frmloc, Toloc, sLatLng, eLatLng, distance) => {

        let passengerInfo = {
            uId: user.uId,
            CityCd: user.CityCd,
            Frmloc: Frmloc,
            Toloc: Toloc,
            lat: sLatLng.lat(),
            lng: sLatLng.lng(),
            endLat: eLatLng.lat(),
            endLng: eLatLng.lng(),
            defaultRate: user.config.defaultRate,
            kms: parseFloat(distance),
            authToken: user.authToken
        }

        try {
            const passDt = await UserService.saveLatLng(passengerInfo);
            setReqNo(passDt.ReqNo)
            // session
            // user.ReqNo = passDt.ReqNo;
            // localStorage.setItem("user", JSON.stringify(user));
            setPassengerRideDataInStorage({
                ReqNo: passDt.ReqNo
            });
            currentLatLng(sLatLng.lat(), sLatLng.lng(), passDt.ReqNo);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    }

    // Function to get lat/lng from an address
    async function getLatLng(address) {
        return new Promise((resolve, reject) => {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ address }, (results, status) => {
                if (status === "OK" && results[0]) {
                    resolve(results[0].geometry.location);
                } else {
                    reject(`Geocode failed for ${address}: ${status}`);
                }
            });
        });
    }

    const handleDriverSelect = async (driver) => {
        // bookedPassengerList(driver)
        let params = {
            uId: user.uId,
            DriveNo: driver.DriveNo,
            authToken: user.authToken
        }
        setBookedPassenger([])
        try {
            const res = await DriverService.getPassengerByDriveNo(params)
            if (res.statusCode === 200) {
                setBookedPassenger(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }

        setDriverMarker(driver); // keep your current selection logic

        const google = window.google;

        // Compute the 4 key points
        const driverStartLatLng = new google.maps.LatLng(driver.lat, driver.lng);
        const driverEndLatLng = new google.maps.LatLng(driver.endLat, driver.endLng);
        const pickupLatLng = new google.maps.LatLng(passenger.lat, passenger.lng);
        const dropLatLng = new google.maps.LatLng(passenger.endLat, passenger.endLng);

        // Draw color-coded route
        renderColorCodedRoutes(
            map,
            driverStartLatLng,
            pickupLatLng,
            dropLatLng,
            driverEndLatLng
        );

    };

    const bookedPassengerList = async (driver) => {
        let params = {
            uId: user.uId,
            DriveNo: driver.DriveNo,
            authToken: user.authToken
        }
        setBookedPassenger([])
        try {
            const res = await DriverService.getPassengerByDriveNo(params)
            if (res.statusCode === 200) {
                setBookedPassenger(res.data)
            }
        } catch (error) {
            alert(error.response?.data?.message || "Something went wrong.");
        }
    }

    function renderColorCodedRoutes(map, driverStart, pickup, drop, driverEnd) {
        const google = window.google;

        // Compute distances
        const distPickupToDrop = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(pickup),
            new google.maps.LatLng(drop)
        );
        const distPickupToDriverEnd = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(pickup),
            new google.maps.LatLng(driverEnd)
        );

        const renderSegment = (origin, destination, color) => {
            const directionsService = new google.maps.DirectionsService();
            directionsService.route({
                origin,
                destination,
                travelMode: google.maps.TravelMode.DRIVING
            }, (result, status) => {
                if (status === "OK") {
                    const renderer = new google.maps.DirectionsRenderer({
                        map,
                        directions: result,
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor: color,
                            strokeWeight: 5,
                        },
                    });
                    setColorPolylines(prev => [...prev, renderer]);
                } else {
                    console.error("Directions request failed:", status);
                }
            });
        };

        //  Blue: driverStart to pickup
        renderSegment(driverStart, pickup, "#0000FF");

        //  Green: pickup to earlier of driverEnd or drop
        const greenEnd = distPickupToDriverEnd < distPickupToDrop ? driverEnd : drop;
        renderSegment(pickup, greenEnd, "#00FF00");

        //  Orange: driver ends before passenger drop
        // Add a small buffer to treat near-equal as equal
        const EPSILON = 20; // meters

        if (distPickupToDriverEnd + EPSILON < distPickupToDrop) {
            console.log("Driver ends before passenger. Rendering orange route.");
            renderSegment(driverEnd, drop, "#FFA500"); // Orange
        } else if (distPickupToDriverEnd > distPickupToDrop + EPSILON) {
            console.log("Driver continues beyond passenger. Rendering yellow route.");
            renderSegment(drop, driverEnd, "#FFFF00"); // Yellow
        } else {
            console.log("Driver and passenger end points are roughly the same. No orange/yellow needed.");
        }

        //  Yellow: driver goes beyond drop
        if (distPickupToDriverEnd > distPickupToDrop) {
            renderSegment(drop, driverEnd, "#FFFF00");
        }
    }

    async function getDriverRoute(driver) {

        return new Promise((resolve, reject) => {
            if (!driver.lat || !driver.lng || !driver.endLat || !driver.endLng) {
                console.warn("Invalid driver data", driver);
                resolve([]);
                return;
            }

            const directionsService = new window.google.maps.DirectionsService();
            directionsService.route(
                {
                    origin: new window.google.maps.LatLng(driver.lat, driver.lng),
                    destination: new window.google.maps.LatLng(driver.endLat, driver.endLng),
                    // waypoints: driver.waypoints || [], // check same route or not
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (result, status) => {
                    if (status === "OK") {
                        const routePath = result.routes[0].overview_path.map(point => ({
                            lat: point.lat(),
                            lng: point.lng(),
                        }));
                        resolve(routePath);
                    } else {
                        console.error("Failed to get driver route:", status);
                        resolve([]);
                    }
                }
            );
        });
    }

    async function getPassengerRoute(passenger) {
        console.log(`lat  ${passenger.lat}`)
        return new Promise((resolve, reject) => {
            if (!passenger.lat || !passenger.lng || !passenger.endLat || !passenger.endLng) {
                console.warn("Invalid passenger data", passenger);
                resolve([]);
                return;
            }

            const directionsService = new window.google.maps.DirectionsService();
            directionsService.route(
                {
                    origin: new window.google.maps.LatLng(passenger.lat, passenger.lng),
                    destination: new window.google.maps.LatLng(passenger.endLat, passenger.endLng),
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (result, status) => {
                    if (status === "OK") {
                        const routePath = result.routes[0].overview_path.map(point => ({
                            lat: point.lat(),
                            lng: point.lng(),
                        }));
                        resolve(routePath);
                    } else {
                        console.error("Failed to get passenger route:", status);
                        resolve([]);
                    }
                }
            );
        });
    }

    function calculateRouteOverlap(driverRoute, passengerRoute) {
        const options = {
            threshold: user.config.OverlapThreshold || 500,         // 500 meters
            step: user.config.OverlapStep || 5,                // every 5th point
            maxOriginDistance: user.maxOriginDistance // meters (2 km) or 500 meter
        };

        const { threshold, step, maxOriginDistance } = options;

        if (!window.google || !window.google.maps || !window.google.maps.geometry) {
            console.error("Google Maps geometry library is not loaded.");
            return 0;
        }

        if (!driverRoute?.length || !passengerRoute?.length) {
            console.warn("Driver or Passenger route is empty.");
            return 0;
        }

        const driverStart = new window.google.maps.LatLng(driverRoute[0].lat, driverRoute[0].lng);
        const passengerStart = new window.google.maps.LatLng(passengerRoute[0].lat, passengerRoute[0].lng);

        const originDistance = window.google.maps.geometry.spherical.computeDistanceBetween(driverStart, passengerStart);

        if (originDistance > maxOriginDistance) {
            console.log(`Skipping: origin too far (${originDistance}m > ${maxOriginDistance}m)`);
            return 0;
        }

        let weightedOverlap = 0;
        let totalWeight = 0;

        const len = passengerRoute.length;

        for (let i = 0; i < len; i += step) {
            const passengerPoint = passengerRoute[i];
            const passengerLatLng = new window.google.maps.LatLng(passengerPoint.lat, passengerPoint.lng);

            const weight = 1 - (i / len); // early points get higher weight (1 to 0)
            totalWeight += weight;

            const isNearDriverRoute = driverRoute.some((driverPoint, j) => {
                if (j % step !== 0) return false;

                const driverLatLng = new window.google.maps.LatLng(driverPoint.lat, driverPoint.lng);
                const distance = window.google.maps.geometry.spherical.computeDistanceBetween(passengerLatLng, driverLatLng);
                return distance < threshold;
            });

            if (isNearDriverRoute) {
                weightedOverlap += weight;
            }
        }

        const overlapPercentage = totalWeight > 0
            ? (weightedOverlap / totalWeight) * 100
            : 0;

        console.log(`Weighted Overlap: ${overlapPercentage.toFixed(2)}%`);
        return overlapPercentage;
    }

    async function canDriverReachPassenger(driver, passenger) {
        return new Promise((resolve, reject) => {
            const service = new window.google.maps.DistanceMatrixService();
            service.getDistanceMatrix(
                {
                    origins: [new window.google.maps.LatLng(driver.lat, driver.lng)],
                    destinations: [new window.google.maps.LatLng(passenger.lat, passenger.lng)],
                    travelMode: window.google.maps.TravelMode.DRIVING,
                },
                (response, status) => {
                    if (status === "OK") {
                        const duration = response.rows[0].elements[0].duration.value / 60; // seconds to minutes
                        resolve(duration <= user.DriverReachPassengerInMinut); // Corrected to 10 minutes
                    } else {
                        console.error("Distance Matrix API failed:", status);
                        resolve(false);
                    }
                }
            );
        });
    }

    function hasDriverPassedPassenger(driverLatLng, passengerLatLng, destinationLatLng) {
        const driverToDest = window.google.maps.geometry.spherical.computeDistanceBetween(driverLatLng, destinationLatLng);
        const passengerToDest = window.google.maps.geometry.spherical.computeDistanceBetween(passengerLatLng, destinationLatLng);

        // If driver is closer to destination than passenger (with 50m buffer), they have passed
        return driverToDest < passengerToDest - user.DriverPassedPassengerInMeter;
    }


    function checkUserOnRoute(user, selectedRoute) {
        if (!selectedRoute) return false;

        const threshold = user.checkUserOnRouteThreshold; // 500 Distance threshold in meters
        return selectedRoute.overview_path.some(routePoint => {
            const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
                new window.google.maps.LatLng(user.lat, user.lng),
                new window.google.maps.LatLng(routePoint.lat(), routePoint.lng())
            );
            return distance < threshold;
        });
    }


    function clearRoute() {
        rideStatusRequestRef.current++;
        activeDriverRef.current = null;
        latestDriverLocationRef.current = null;
        setActiveDriver(null);
        setDirectionsResponse(null)
        setDistance('')
        setDuration('')
        setSelectedRouteIndex(0)
        setWaypoints([]);
        setOrigin("")
        setDestination("")
        waypointRefs.current.forEach(ref => ref.current && (ref.current.value = ''));
        setDrivers([]);
        setDriverMarker(null);
        setPassengerMarker(null);
        setBookedPassenger([]);

        setDriverRoute([]);
        setPassenger({});
        setReqNo(0);
        setReqStat(0);
        colorPolylines.forEach(renderer => renderer.setMap(null));
        setColorPolylines([]);
        clearPassengerRideData()
    }

    function handleSelectRoute(index) {

        if (selectedRouteIndex === index) {
            setSelectedRouteIndex(null); // Deselect if clicked again
        } else {
            setSelectedRouteIndex(index);// Select new route
        }

        const selected = directionsResponse.routes[index]
        setDistance(selected.legs[0].distance.text)
        setDuration(selected.legs[0].duration.text)
    }

    const openDrawerWithData = (driverData) => {

        setDriverInfo({
            DriveNo: driverData.DriveNo,
            DriverId: driverData.DriverId,
            Name: `${driverData.users.FName} ${driverData.users.LName}`,
        });

        // session
        // user.DriverId = driverData.DriverId;
        // user.DriveNo = driverData.DriveNo;
        // localStorage.setItem("user", JSON.stringify(user));

        setPassengerRideDataInStorage({
            DriverId: driverData.DriverId,
            DriveNo: driverData.DriveNo
        });

        let driveNo = driverData.DriveNo;
        if (driveNo > 0) {
            getChats(driveNo);
            passengerReply(driveNo);
            onOpen();
        }
    }

    const handleOptionSelect = async (rpl, textMsg, rate) => {
        try {
            if (rpl.MsgId === 24) {
                textMsg = `${textMsg} (${paymentMode})`;
            }
            let params = {};
            params.DriveNo = DriverInfo.DriveNo;
            params.DriverId = DriverInfo.DriverId;
            params.uId = user.uId;
            params.MsgId = rpl.MsgId;
            params.Rate = Number(rate);
            params.msg = textMsg;
            params.PStat = Number(rpl.PStat);
            params.DStat = Number(rpl.DStat);
            params.SendBy = user.uId;
            params.MobileNo = user.MobileNo;
            params.authToken = user.authToken;

            // for passenger picked dropped
            params.ReqNo = ReqNo;
            params.RLat = location.lat;
            params.RLng = location.lng;

            await UserService.savePassengerReply(params);
            socketRef.current.emit("send_message", {
                senderId: user.uId,
                receiverId: DriverInfo.DriverId,
                messageData: rpl
            })
            if (rpl.MsgId == 24) {
                openRatingModal()
            }

            if (rpl.MsgId === 4 || rpl.MsgId === 7) {
                setReqStat(1)
                getOnlyBookedDriver();
                setSearchSection(false)
            }

            if (rpl.MsgId === 19 || rpl.MsgId === 22 || rpl.MsgId === 29) {
                rideStatusRequestRef.current++;
                activeDriverRef.current = null;
                latestDriverLocationRef.current = null;
                setActiveDriver(null);
                setReqNo(0)
                // session
                // user.ReqNo = 0;
                // localStorage.setItem("user", JSON.stringify(user));
                setPassengerRideDataInStorage({
                    ReqNo: 0
                });
            }

            getChats(DriverInfo.DriveNo);
            passengerReply(DriverInfo.DriveNo);
            if (rpl.MsgId == 29) {
                clearIntervalOnly();
                clearRoute();
            }
        }
        catch (error) {
            if (error?.response?.data?.message) {
                alert(error.response.data.message);
            }
        }
    };

    const handlePaymentModeChange = (e) => {
        setPaymentMode(e.target.value);
    };

    const openRatingModal = () => {
        setIsRatingModalOpen(true);
    };

    const closeRatingModal = () => {
        setIsRatingModalOpen(false);
        clearIntervalOnly()
        clearRoute()
    };

    return (

        <Flex
            position='relative'
            flexDirection='column'
            alignItems='center'
            h='100vh'
            w='100vw'
        >
            <Box position='absolute' left={0} top={0} h='100%' w='100%'>
                <GoogleMap
                    center={center}
                    zoom={15}
                    mapContainerStyle={{ width: '100%', height: '100%' }}
                    options={{
                        zoomControl: true,
                        streetViewControl: false,
                        mapTypeControl: false,
                        fullscreenControl: false,
                    }}
                    onLoad={map => setMap(map)}
                >

                    {/** passenger */}
                    {location && (
                        <Marker
                            position={location}
                            icon={{
                                url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
                            }}
                            onClick={() => setPassengerMarker(location)}
                            zIndex={1000}
                        />
                    )}

                    {directionsResponse && (
                        <>
                            {/* Render Selected Route using DirectionsRenderer */}
                            <DirectionsRenderer
                                directions={selectedDirections}
                                options={{
                                    suppressMarkers: true,
                                    polylineOptions: {
                                        strokeColor: "blue", // Selected route color
                                        strokeOpacity: 0.8,
                                        strokeWeight: 5,
                                    },
                                }}
                            />
                            <RouteMarkers
                                route={directionsResponse.routes[selectedRouteIndex]}
                                liveOrigin={parseLocation(activeDriver)}
                            />

                            {/* Render Alternative Routes using Polyline */}
                            {directionsResponse.routes.map((route, idx) =>
                                idx !== selectedRouteIndex ? (
                                    <Polyline
                                        key={idx}
                                        path={route.overview_path.map((point) => ({
                                            lat: point.lat(),
                                            lng: point.lng(),
                                        }))}
                                        options={{
                                            strokeColor: idx === selectedRouteIndex ? "blue" : "gray",
                                            strokeOpacity: 0.6,
                                            strokeWeight: idx === selectedRouteIndex ? 5 : 4,
                                            zIndex: idx === selectedRouteIndex ? 2 : 1, // Bring selected route to front
                                        }}
                                        onClick={() => handleSelectRoute(idx)}
                                    />
                                ) : null
                            )}
                        </>
                    )}

                    {directionsResponse && (
                        <MarkerClusterer>
                            {(clusterer) =>
                                Drivers.map((user) => {
                                    const isUserOnSelectedRoute = checkUserOnRoute(user, directionsResponse.routes[selectedRouteIndex]);

                                    // Determine icon URL based on VTyp and isUserOnSelectedRoute
                                    let iconUrl = "";
                                    if (user.VTyp === 2) {
                                        iconUrl = isUserOnSelectedRoute
                                            ? "/assets/images/bike.png"
                                            : "/assets/images/redbike.png";
                                    } else if (user.VTyp === 4) {
                                        iconUrl = isUserOnSelectedRoute
                                            ? "/assets/images/greencar.png" // Green car if on route
                                            : "/assets/images/car.png";     // Normal car otherwise
                                    } else {
                                        // Default icon if VTyp is unknown
                                        iconUrl = "http://maps.google.com/mapfiles/ms/icons/green-dot.png";
                                    }

                                    return (
                                        <Marker
                                            key={user.DriveNo}
                                            position={{ lat: Number(user.lat), lng: Number(user.lng) }}
                                            clusterer={clusterer}
                                            icon={{
                                                url: iconUrl,
                                                scaledSize: new window.google.maps.Size(40, 40),
                                            }}

                                            onClick={() => handleDriverSelect(user)}

                                            zIndex={999}
                                        />
                                    );
                                })
                            }
                        </MarkerClusterer>
                    )}

                    {driverMarker && (
                        <InfoWindow
                            position={{ lat: driverMarker.lat, lng: driverMarker.lng }}
                            onCloseClick={() => {
                                // Close InfoWindow

                                // Deselect driver and clear route lines
                                setDriverMarker(null);

                                colorPolylines.forEach(polyline => polyline.setMap(null));
                                setColorPolylines([]);
                            }}
                            options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
                        >
                            <Box
                                p={3}
                                borderRadius="md"
                                bg="white"
                                boxShadow="lg"
                                minW={{ base: "100%", sm: "220px" }} // full width on small screens
                                maxW={{ base: "100%", sm: "300px" }} // optional: limit width on small screens
                            >
                                {/* Profile Section */}
                                <Flex align="center" justify="flex-start" mb={2}>
                                    <Avatar
                                        src={`${backendUrl}/profile/${driverMarker?.users?.ProfilePic}`}
                                        name={`${driverMarker?.users?.FName} ${driverMarker?.users?.LName}`}
                                        size="md"
                                        mr={3}
                                    />
                                    <Box>
                                        <Text fontWeight="bold" fontSize="md">
                                            {driverMarker?.users?.FName} {driverMarker?.users?.LName}
                                        </Text>
                                        <Text fontSize="sm" color="gray.600">
                                            Age: {calculateAge(driverMarker?.users?.DOB)}, ({getGender(driverMarker?.users?.Gender)})
                                        </Text>
                                    </Box>
                                </Flex>

                                <Divider my={2} />

                                {/* Vehicle Details */}
                                <Box>
                                    <Text fontSize="sm">
                                        🚗 <strong>Car:</strong> {driverMarker?.drivervehicle?.VMake} {driverMarker?.drivervehicle?.VModel}
                                    </Text>
                                    <Text fontSize="sm">
                                        🎨 <strong>Color:</strong> {driverMarker?.drivervehicle?.VColor}
                                    </Text>
                                    <Text fontSize="sm">
                                        🔢 <strong>Number:</strong> {driverMarker?.drivervehicle?.VNo}
                                    </Text>
                                    <Text fontSize="sm">
                                        📍 <strong>Trip count:</strong> {driverMarker?.completedRideCount || 0}
                                    </Text>
                                    <Text fontSize="sm">
                                        ⭐<strong>Ratings</strong> <br /><br />
                                        <span><strong>Driver:</strong> {driverMarker?.rating?.Driver} </span>
                                        <span><strong>Driving:</strong> {driverMarker?.rating?.Driving} </span>
                                        <span><strong>Vehicle:</strong> {driverMarker?.rating?.Vehicle}</span>
                                    </Text>
                                </Box>

                                {driverMarker.users.Premium > 0 && (
                                    <>
                                        <Divider my={2} />

                                        {/* Premium Features */}
                                        <Box>
                                            <Text fontSize="sm">🎵 <strong>Music:</strong> {getMusic(driverMarker.users.Music)}</Text>
                                            <Text fontSize="sm">🍔 <strong>Eat:</strong> Allowed</Text>
                                            <Text fontSize="sm">🚬 <strong>Smoking:</strong> Allowed</Text>
                                            <Text fontSize="sm">⏱️ <strong>ETA:</strong> 10 mins</Text>
                                        </Box>
                                    </>
                                )}

                                <Divider my={2} />

                                {/* Location Info */}
                                {/* <Text fontSize="xs" color="gray.500">
                                    📍 Lat: {driverMarker.lat} | Lng: {driverMarker.lng}
                                </Text> */}
                                <Text fontSize="xs" color="gray.500">
                                    🚗 Drive No: {driverMarker.DriveNo}
                                </Text>

                                {/* booked passenger */}
                                <Box>
                                    <Text fontWeight="bold" fontSize="sm">
                                        Passengers
                                    </Text>
                                    {bookedPassenger.map((pass, ind) => (
                                        <React.Fragment key={ind}>
                                            <Divider my={2} />
                                            <Box textAlign={{ base: "center", sm: "left" }}>
                                                <Text fontWeight="bold" fontSize="sm">
                                                    {pass.FName} {pass.LName}
                                                </Text>
                                                <Text fontSize="sm" color="gray.600">
                                                    Age: {calculateAge(pass.DOB)}, ({getGender(pass.Gender)})
                                                </Text>
                                            </Box>
                                        </React.Fragment>
                                    ))}

                                </Box>

                                {/* Chat Button */}
                                {driverMarker.drivervehicle?.maxSeat > bookedPassenger.length ? (
                                    <Flex align="center" justify="flex-start" mt={2}>
                                        <IconButton
                                            aria-label="Chat"
                                            icon={<FaRocketchat />}
                                            ref={btnRef}
                                            size="sm"
                                            colorScheme="teal"
                                            onClick={() => openDrawerWithData(driverMarker)}
                                            w="100%"
                                        />
                                    </Flex>
                                ) : (
                                    <Text color="red.500" mt={2}>Vehicle is full</Text>
                                )}

                            </Box>

                        </InfoWindow>
                    )}

                    {passengerMarker && (
                        <InfoWindow
                            position={{ lat: passengerMarker.lat, lng: passengerMarker.lng }}
                            onCloseClick={() => setPassengerMarker(null)}
                            options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
                        >
                            <Box
                                p={4}
                                borderRadius="md"
                                bg="white"
                                boxShadow="lg"
                                minW={{ base: "100%", sm: "220px" }}
                                maxW={{ base: "100%", sm: "300px" }}
                            >
                                {/* Profile Section */}
                                <Flex direction={{ base: "column", sm: "row" }} align="center" mb={2}>
                                    <Avatar
                                        src={`${backendUrl}/profile/${user.ProfilePic}`}
                                        name={`${user.FName} ${user.LName}`}
                                        size="md"
                                        mr={{ base: 0, sm: 3 }}
                                        mb={{ base: 2, sm: 0 }}
                                    />
                                    <Box textAlign={{ base: "center", sm: "left" }}>
                                        <Text fontWeight="bold" fontSize="md">
                                            {user.FName} {user.LName}
                                        </Text>
                                        <Text fontSize="sm" color="gray.600">
                                            Age: {calculateAge(user.DOB)}, ({getGender(user.Gender)})
                                        </Text>
                                    </Box>
                                </Flex>

                                {/* Premium Features */}
                                {user.Premium > 0 && (
                                    <>
                                        <Divider my={2} />
                                        <Box>
                                            <Text fontSize="sm">🎵 <strong>Music:</strong> {getMusic(user.Music)}</Text>
                                            <Text fontSize="sm">🍔 <strong>Eat:</strong> Allowed</Text>
                                            <Text fontSize="sm">🚬 <strong>Smoking:</strong> Allowed</Text>
                                            <Text fontSize="sm">⏱️ <strong>ETA:</strong> 10 mins</Text>
                                        </Box>
                                    </>
                                )}
                            </Box>

                        </InfoWindow>
                    )}

                </GoogleMap>
            </Box>

            {searchSection && (
                <Box
                    p={4}
                    borderRadius="lg"
                    m={4}
                    bgColor="white"
                    shadow="base"
                    minW={{ base: '100%', md: 'container.md' }} // Responsive min width
                    zIndex="1"
                >
                    <Stack
                        direction={{ base: 'column', md: 'row' }} // Stack items vertically on mobile
                        spacing={2}
                        justifyContent="space-between"
                    >
                        <Box flexGrow={1}>
                            <Autocomplete
                                onLoad={(autocomplete) => (originRef.current = autocomplete)}
                                onPlaceChanged={handleOrigin}
                            >
                                <Input type="text" placeholder="Origin" size="sm" value={origin}
                                    onChange={(e) => setOrigin(e.target.value)}
                                />
                            </Autocomplete>
                        </Box>

                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="waypoints">
                                {(provided) => (
                                    <VStack
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        spacing={3}
                                        align="stretch"
                                    >
                                        {waypoints.map((waypoint, index) => (
                                            <Draggable key={index} draggableId={`waypoint-${index}`} index={index}>
                                                {(provided) => (
                                                    <HStack
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        spacing={2}
                                                    >
                                                        <Box {...provided.dragHandleProps} cursor="grab" p={2}>
                                                            <FaGripVertical />
                                                        </Box>

                                                        <Autocomplete
                                                            onLoad={(autocomplete) => (waypointRefs.current[index] = autocomplete)}
                                                            onPlaceChanged={() => handlePlaceChanged(index)}
                                                        >
                                                            <input
                                                                value={localWaypointValues[index] || ""}
                                                                onChange={(e) => handleInputChange(index, e.target.value)}
                                                                placeholder={`Waypoint ${index + 1}`}
                                                                style={{
                                                                    flex: 1,
                                                                    padding: '6px',
                                                                    borderRadius: '4px',
                                                                    border: '1px solid #ccc',
                                                                }}
                                                            />
                                                        </Autocomplete>

                                                        <IconButton
                                                            aria-label="Remove waypoint"
                                                            icon={<FaTimes />}
                                                            onClick={() => removeWaypoint(index)}
                                                            size="sm"
                                                            colorScheme="red"
                                                        />

                                                    </HStack>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </VStack>
                                )}
                            </Droppable>
                        </DragDropContext>

                        <Box flexGrow={1}>
                            <Autocomplete
                                onLoad={(autocomplete) => (destinationRef.current = autocomplete)}
                                onPlaceChanged={handleDestination}
                            >
                                <Input type="text" placeholder="Destination" size="sm" value={destination}
                                    onChange={(e) => setDestination(e.target.value)} />
                            </Autocomplete>
                        </Box>

                        <ButtonGroup flexShrink={0} flexWrap="wrap">

                            <IconButton
                                aria-label="Waypoint"
                                icon={<FaPlus />}
                                colorScheme="blue"
                                onClick={addWaypoint} size="sm"
                            />
                            <IconButton
                                aria-label="Search"
                                icon={<FaSearch />}
                                colorScheme="pink"
                                onClick={calculateRoute} size="sm"
                            />

                            <IconButton
                                aria-label="center back"
                                icon={<FaTimes />}
                                onClick={clearRoute}
                                size="sm"
                            />

                            <IconButton
                                aria-label="center back"
                                icon={<FaLocationArrow />}
                                isRound
                                onClick={() => {
                                    map.panTo(center);
                                    map.setZoom(15);
                                }}
                                size="sm"
                            />

                            {ReqNo > 0 && ReqStat < 1 && (
                                <IconButton
                                    aria-label="New Driver"
                                    icon={<FaCar />}
                                    onClick={getNewDriver}
                                    size="sm"
                                />
                            )}
                        </ButtonGroup>
                    </Stack>

                    <Stack
                        direction="row" // 👈 Always horizontal
                        spacing={4}
                        mt={4}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Text>Distance: {distance}</Text>
                        <Text>Duration: {duration}</Text>
                    </Stack>
                </Box>
            )}

            <Drawer
                isOpen={isOpen}
                placement='right'
                onClose={onClose}
                finalFocusRef={btnRef}
            >
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>Chat with {DriverInfo.Name}</DrawerHeader>

                    <DrawerBody>
                        <Stack spacing='24px'>
                            <Box>
                                <VStack spacing={3} align="stretch" overflowY="auto">
                                    {messages.map((item, index) => (
                                        <Text
                                            key={index}
                                            bg={item.SendBy === user.uId ? "blue.200" : "gray.200"}
                                            alignSelf={item.SendBy === user.uId ? "flex-end" : "flex-start"}
                                            p={2}
                                            borderRadius="md"
                                        >
                                            {item.msg}
                                        </Text>
                                    ))}
                                </VStack>
                            </Box>

                        </Stack>
                    </DrawerBody>
                    <DrawerFooter>
                        {/* Single Selection Reply Options */}
                        <Box textAlign="right">
                            <VStack mt={3} spacing={3}>
                                {reply.map((item, index) => {
                                    let textMsg = item.Msg;

                                    if (item.MsgId === 2 && item.Msg && destination) {
                                        textMsg = item.Msg
                                            .replace(/from\s+_+/, `from ${origin}`)
                                            .replace(/to\s+_+/, `to ${destination}`);
                                    }

                                    // TStat == 0: Show only badge
                                    if ((item.TStat === 0 && item.MsgId != 5) || item.MsgId == 15 || item.MsgId == 22) {
                                        return (
                                            <WrapItem key={`reply-${index}`}>
                                                <Button
                                                    onClick={() => handleOptionSelect(item, textMsg, amount)}
                                                    colorScheme="yellow"
                                                    cursor="pointer"
                                                    size="xs"
                                                    px={3}
                                                    whiteSpace="normal"
                                                    minHeight="30px"
                                                    height="auto"
                                                >
                                                    {textMsg}
                                                </Button>
                                            </WrapItem>
                                        );
                                    }

                                    // TStat != 0: Show input + badge
                                    return (
                                        <VStack key={`reply-input-${index}`} spacing={2}>
                                            {item.MsgId === 24 && (
                                                <Select
                                                    size="xs"
                                                    placeholder="Select Payment Mode"
                                                    value={paymentMode}
                                                    onChange={handlePaymentModeChange}
                                                >
                                                    <option value="Cash">Cash</option>
                                                    <option value="Online">Online</option>
                                                </Select>
                                            )}
                                            <HStack spacing={2}>
                                                <WrapItem>
                                                    <Button
                                                        onClick={() => handleOptionSelect(item, `${textMsg} ${amount}`, amount)}
                                                        colorScheme="yellow"
                                                        isDisabled={!amount}
                                                        cursor="pointer"
                                                        size="xs"
                                                        whiteSpace="normal"
                                                    >
                                                        {textMsg} {amount}
                                                    </Button>
                                                </WrapItem>
                                                <Input
                                                    type="number"
                                                    placeholder="Amount"
                                                    value={amount}
                                                    size="xs"
                                                    width="60px"
                                                    onChange={(e) => setAmount(e.target.value)}
                                                />
                                            </HStack>
                                        </VStack>
                                    );
                                })}
                            </VStack>
                        </Box>

                    </DrawerFooter>
                </DrawerContent>
            </Drawer>
            <Box mt="auto" w="100%" bgColor='white'
                shadow='base'
                zIndex='1'>
                <Footer />
            </Box>
            <DriverRatingModal
                isOpen={isRatingModalOpen}
                onClose={closeRatingModal}
                DriveNo={DriverInfo.DriveNo}
                DriverID={DriverInfo.DriverId}
                PassengerID={user.uId}
            />
        </Flex>

    );
}

export default UserMapWithDirection;
